/**
 * Ryan O'Dowd
 * 2024-01-06
 * © Copyright 2024 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import ActivityIndicator from '@components/common/ActivityIndicator';
import FullScreenScrollView from '@components/common/FullScreenScrollView';
import React from 'react';
import {
  View,
} from 'react-native';
import getStyles from './styles';
import hooks from '@hooks';

const ScreenLoader = () => {
  const styles = hooks.useStyles(getStyles);

  return (
    <FullScreenScrollView>
      <View style={styles.container}>
        <ActivityIndicator size='large' color={styles.colors.white} />
      </View>
    </FullScreenScrollView>
  );
};

export default ScreenLoader;
